import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Nav, NavItem } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import MainNavigation from "../../.sourceflow/new_navigation.json";
import React, { useState, useEffect } from "react";
import SearchIcon from "/public/site-assets/svg/black-magnifying-glass.svg";
import CloseMark from "/public/site-assets/svg/close-mark.svg";
import Telephone from "/public/site-assets/svg/telephone.svg";
import News from "../../.sourceflow/news.json";
import SectorsData from "../../.sourceflow/sectors.json";
import SolutionsData from "../../.sourceflow/solutions.json";
import Fuse from "fuse.js";
import clsx from 'classnames';
import { useRouter } from 'next/router';
import PoweredByBanner from "../PoweredByBanner";

export default function MainHeader({ pathPrefix }) {
  const dropdownRefs = {};
  const router = useRouter();
  const isHomepage = router.pathname === "/";
  const [isOpen, setIsOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isBannerHidden, setIsBannerHidden] = useState(false);
  const toggleSearch = () => {
    setIsSearchOpen((prev) => {
      if (prev) {
        setSearchQuery("");
        setSearchResults([]);
      }
      return !prev;
    });
  };
  
  // Now filter based on selectedNavigation
  const ParentMainNavigation = MainNavigation.category_values.filter(post => post.parent.identifier === null);
  const ChildrenMainNavigation = MainNavigation.category_values.filter(post => post.parent.identifier !== null);

  const [activeDropdown, setActiveDropdown] = useState(null);

  const newToggleDropdown = (titleEn) => {
    
    // Remove 'active' class from all elementsAdd commentMore actions
    document.querySelectorAll("[data-parent-id]").forEach((el) => {
      el.classList.remove("active");
    });
    
    setActiveDropdown(activeDropdown === titleEn ? null : titleEn);
    
    // Find the parent element with matching data-parent-id
    const parentElement = document.querySelector(`[data-parent-id="${titleEn}"]`);

    if (parentElement) {
      const isActive = parentElement.classList.contains("active");

      // Remove 'active' class from all elements
      document.querySelectorAll("[data-parent-id]").forEach((el) => {
        el.classList.remove("active");
      });

      // Toggle the clicked element only if it wasn't active before
      if (!isActive) {
        parentElement.classList.add("active");
      }
    }
  };

  useEffect(() => {
      const handleClickOutside = (event) => {
        // Check if the clicked element is inside any data-parent-id element
        if (!event.target.closest("[data-parent-id]") && !event.target.closest(".dropdown") && !event.target.closest(".nav")) {
          setActiveDropdown(null);
  
          document.querySelectorAll("[data-parent-id]").forEach((el) => {
            el.classList.remove("active");
          });
        }
      };
  
      document.addEventListener("mouseover", handleClickOutside);
      return () => {
        document.removeEventListener("mouseover", handleClickOutside);
      };
    }, []);

  const AllInsights = [...News.category_values];
  let insights = [];
  AllInsights.map((post) => {
    insights.push({
      'title': post.title,
      'image': post.image,
      'url_slug': post.url_slug,
      'featured_on_navigation': post.featured_on_navigation ?? null,
    });
  });

  const staticPages = [
    { title: "Home", url: "/", category: "Page" },
    { title: "Jobs", url: "/jobs", category: "Page" },
    { title: "Job Seekers", url: "/job-seekers", category: "Page" },
    { title: "Featured Employers", url: "/job-seekers/featured-employers", category: "Page" },
    { title: "Join Our Talent Network", url: "/job-seekers#join-our-talent-network", category: "Page" },
    { title: "Business Solutions", url: "/business-solutions", category: "Page" },
    { title: "News & Insights", url: "/news-and-insights", category: "Page" },
    { title: "Contact Us", url: "/contact-us", category: "Page" },
    { title: "Contractors", url: "/contractors", category: "Page" },
    { title: "About Us", url: "/about-us", category: "Page" },
    { title: "Meet the Team", url: "/about-us/meet-the-team", category: "Page" },
    { title: "Partnerships", url: "/about-us/partnerships", category: "Page" },
  ];

  const newsPages = News.category_values.map((post) => ({
    title: post.title?.en ?? "",
    url: `/news-and-insights/${post.url_slug}`,
    category: "News & Insights",
  }));

  const sectorPages = SectorsData.category_values.map((sector) => ({
    title: sector.title?.en ?? "",
    url: `/sectors/${sector.url_slug}`,
    category: "Sector",
  }));

  const solutionPages = SolutionsData.category_values.map((solution) => ({
    title: solution.title?.en ?? "",
    url: `/business-solutions/${solution.url_slug}`,
    category: "Business Solution",
  }));

  const allPages = [...staticPages, ...newsPages, ...sectorPages, ...solutionPages];

  const featuredPost = insights
    ?.filter((post) => post?.featured_on_navigation?.en === true)
    .slice(0, 1);


  // Mobile Dropdowns
  const [activeParent, setActiveParent] = useState(null);
  const handleParentClick = (parentTitle) => {
    setActiveParent((prev) => (prev === parentTitle ? null : parentTitle));
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const fuse = new Fuse(allPages, {
    includeScore: true,
    keys: ["title"],
    threshold: 0.4,
  });

  const handleSearch = (query) => {
    setSearchResults(query ? fuse.search(query) : []);
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    handleSearch(query);
  };

  // ReciteMe Script
  useEffect(() => {
    const enableReciteButton = document.getElementById("reciteEnable");

      // Check if the loadService function exists
      if (typeof loadService !== "function") {
        return;
      }

    if (enableReciteButton) {
      enableReciteButton.addEventListener("click", loadService);
    }

    return () => {
      if (enableReciteButton) {
        enableReciteButton.removeEventListener("click", loadService);
      }
    };
  }, []);

  return (
    <>
      <section
        className={`${styles.root} main-navigation ${isOpen ? "active" : ""}`}
      >
        <div className="reciteWrapper py-2 bg-white">
          <Container>
            <button
              className="recite-btn p-0"
              id="reciteEnable"
              aria-label="Accessibility and Languages"
            >
              Accessibility and Languages
            </button>
          </Container>
        </div>
        {isHomepage && <PoweredByBanner onHiddenChange={setIsBannerHidden} />}
        <Container className="position-relative mainWrapper">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <Link href="/">
                <a className="logo me-md-5" aria-label="Bartech Staffing" title="Bartech Staffing">
                    <img src="/site-assets/images/bartech-vertage-logo-white.png" alt="Bartech Staffing, powered by Vertage" width="200" height="56" />
                </a>
              </Link>
              <Nav className="d-none d-lg-flex">
                {ParentMainNavigation.map((post, index) => (
                  <NavItem key={index} className={`parent mx-1 m-xxxl-2 ${activeDropdown === post?.title.en ? "active" : ""}`}>
                    <button
                      className={`dropdown ${post.parent.identifier === null ? "has-children" : null}`}
                      aria-label={`${post?.title.en}`}
                      onMouseEnter={() => newToggleDropdown(post?.title.en)}
                      ref={(ref) => (dropdownRefs[post?.title.en] = ref)}
                    >
                      {post?.title.en}
                    </button>
                  </NavItem>
                ))}
              </Nav>
            </div>
            <div className="d-flex align-items-center d-md-flex">
              <button
                className="search-icon d-flex d-none d-lg-inline-flex"
                aria-label="Search"
                onClick={toggleSearch}
              >
                <SearchIcon />
              </button>
              <Link href="/job-seekers#join-our-talent-network">
                <a className="primaryBtn no-arrow text-nowrap m-0 d-none d-lg-inline-block ms-2">
                  Join Our Talent Network
                </a>
              </Link>
              <Link href="/contact-us">
                <a
                  className="secondaryBtn no-arrow text-nowrap m-0 ms-2"
                  aria-label="Contact Us"
                >
                  <span className="telephone-icon me-lg-2">
                    <Telephone />
                  </span>
                  <span className="d-none d-lg-inline-block">Contact Us</span>
                </a>
              </Link>
              <button
                aria-label="Menu"
                className={`d-inline-block d-lg-none mobile-menu ms-2 position-relative ${isOpen ? "active" : ""
                  }`}
                onClick={() => setIsOpen((isOpen) => !isOpen)}
              >
                Menu
              </button>
            </div>
          </div>
        </Container>
        {ParentMainNavigation.length > 0 &&
          <div className="d-none d-lg-block">
            {ParentMainNavigation.map((parentPost, parentIndex) => {
              const childrenForParent = ChildrenMainNavigation.filter((childPost) => childPost.parent.id === parentPost.id);
              // Skip rendering if no children exist
              if (childrenForParent.length === 0) {
                return null; // Exit early
              }
              return (
                <div className={clsx('dropdownItem')} data-parent-id={parentPost.title.en}>
                  <div className="d-flex">
                    <div className="left-column col-4 p-4">
                      {(parentPost.title.en != "Insights") && (
                        <div>
                          <a href={parentPost.button_url.en}>
                            <SourceFlowImage
                              src={parentPost.image?.en ?? "/site-assets/placeholders/img-placeholder.jpg"}
                              size="500x250"
                              alt={`${parentPost.title.en}`}
                              className={`mb-4 featured-image w-100`}
                              />
                          </a>
                          <div className="mb-4 post-description">
                            <h5>{parentPost.title.en}</h5>
                            <p>{parentPost.text.en}</p>
                          </div>
                        </div>
                      )}
                      {(parentPost.title.en === "Insights" && (
                        <div>
                          {featuredPost && (
                            <div>
                              <div className="featured-insights-image-wrapper position-relative">
                                <div key={featuredPost.id}>
                                  {featuredPost.map((post) =>
                                    <a href={`/news-and-insights/${post.url_slug}`}>
                                      <SourceFlowImage
                                        src={post.image.en}
                                        size="500x250"
                                        alt={`${post.title.en}`}
                                        className={`mb-4 featured-image w-100`}
                                      />
                                    </a>
                                  )}
                                </div>

                              </div>
                              {featuredPost.map((post) =>
                                <a href={`/news-and-insights/${post.url_slug}`}>
                                  <h5 className="fw-bold text-white">{parentPost.text.en}</h5>
                                  <div className="mb-4 post-description post-blog">{post.title.en}</div>
                                </a>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                      <div className="primaryBtn-wrapper m-0 w-100 justify-content-center">
                        <p><a href={parentPost.button_url.en}>{parentPost.button_title.en}</a></p>
                      </div>
                    </div>
                    <div className='right-column p-4 w-100'>
                      <div className="wrapper">
                        {ChildrenMainNavigation.filter((childPost) => childPost.parent.id === parentPost.id).map((childPost, childpostIndex) => (
                          <div className='child-nav' key={childPost.id}>
                            <div>
                              {childPost.new_tab?.en ?
                                <a className='sub-item-parent post-title' href={childPost.url.en} target="_blank" rel="noopener noreferrer">
                                  {childPost.title.en}
                                </a>
                                :
                                !childPost.url.en || childPost.url.en === "#" ?
                                  <div className="sub-item-parent no-link post-title">{childPost.title.en}</div>
                                  :
                                  <a className='sub-item-parent post-title' href={childPost.url.en}>
                                    {childPost.title.en}
                                  </a>
                              }
                              {childPost.text?.en && <div className='post-subtitle mb-4 mt-2'>{childPost.text.en}</div>}
                            </div>
                            {ChildrenMainNavigation.filter((sub_childPost) => sub_childPost.parent.id === childPost.id).map((sub_childPost) => (
                              <div key={sub_childPost.id}>
                                {sub_childPost.new_tab?.en ?
                                  <a className='sub-item post-title' href={sub_childPost.url.en} target="_blank" rel="noopener noreferrer">
                                    {sub_childPost.title.en}
                                  </a> :
                                  <a className='sub-item post-title' href={sub_childPost.url.en}>
                                    {sub_childPost.title.en}
                                  </a>
                                }
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        }
      </section>
      <div className={`${styles.root} mobile-dropdown ${isOpen ? "active" : "overflow-hidden"} ${isHomepage && !isBannerHidden ? "has-powered-by-banner" : ""} d-inline-block d-lg-none`}>
        <div className="d-flex flex-wrap justify-content-between mobileWrapper">
          <div className="w-100">
            {/* MOBILE */}
            <Nav className={`d-flex flex-wrap`}>
              {!activeParent && (
                <>
                  <NavItem className={`parent w-100`}>
                    <a href="/">
                      Home
                    </a>
                  </NavItem>

                  {ParentMainNavigation.map((post, index) => (
                    <NavItem key={index} className={`parent w-100`}>
                      <button
                        className={`bg-transparent dropdown w-100 text-start ${post.parent.identifier === null ? "has-children" : null
                          }`}
                        aria-label={`${post?.title.en}`}
                        onClick={() => handleParentClick(post.title.en)}
                      >
                        <strong>{post?.title.en}</strong>
                      </button>
                    </NavItem>
                  ))}
                </>
              )}
              {activeParent && (
                <NavItem className={`parent w-100 return-btn-wrapper`}>
                  <button
                    className={`border-0 bg-transparent px-0 dropdown w-100 text-start`}
                    onClick={() => setActiveParent(null)}
                  >
                    Back
                  </button>
                </NavItem>
              )}
            </Nav>
            {ParentMainNavigation.length > 0 &&
              <div className="sub-children-wrapper">
                {ParentMainNavigation.map((parentPost, parentIndex) => {
                  const childrenForParent = ChildrenMainNavigation.filter((childPost) => childPost.parent.id === parentPost.id);
                  // Skip rendering if no children exist
                  if (childrenForParent.length === 0) {
                    return null; // Exit early
                  }
                  return (
                    <div
                      className={clsx("dropdownItem", {
                        active: activeParent === parentPost.title.en,
                      })}
                      data-mobile-parent-id={parentPost.title.en}
                    >
                      {(parentPost.title.en === "Employers" || parentPost.title.en === "Specialism" || parentPost.title.en === "Markets") && (
                        <div className="sub-children-title">{parentPost.title.en}</div>
                      )}
                      <div className="wrapper">
                        {ChildrenMainNavigation.filter((childPost) => childPost.parent.id === parentPost.id).map((childPost) => (
                          <div className='child-nav' key={childPost.id}>
                            <div>
                              {childPost.new_tab?.en ?
                                <a className='sub-item-parent post-title' href={childPost.url.en} target="_blank" rel="noopener noreferrer">
                                  {childPost.title.en}
                                </a>
                                :
                                !childPost.url.en || childPost.url.en === "#" ?
                                  <div className="sub-item-parent no-link post-title">{childPost.title.en}</div>
                                  :
                                  <a className='sub-item-parent post-title' href={childPost.url.en}>
                                    {childPost.title.en}
                                  </a>
                              }
                              {ChildrenMainNavigation.filter((sub_childPost) => sub_childPost.parent.id === childPost.id).map((sub_childPost) => (
                                <div className="sub-item-child" key={sub_childPost.id}>
                                  {sub_childPost.new_tab?.en ?
                                    <a className='sub-item' href={sub_childPost.url.en} target="_blank" rel="noopener noreferrer">
                                      {sub_childPost.title.en}
                                    </a> :
                                    <a className='sub-item' href={sub_childPost.url.en}>
                                      {sub_childPost.title.en}
                                    </a>
                                  }
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                })}
              </div>
            }
          </div>
        </div>
      </div>
      {isSearchOpen && (
        <section className={`${styles.root} site-search d-none d-md-block`}>
          <Container>
            <div className="d-flex align-items-center">
              <div className="w-100 position-relative filters">
                <input
                  type="text"
                  id="search"
                  placeholder="Site Search..."
                  onChange={handleSearchChange}
                  value={searchQuery}
                />
                <span className="icon d-inline-block position-absolute">
                  <SearchIcon />
                </span>
              </div>
              <button
                className={`primaryBtn no-arrow border-0 m-0 ms-3`}
                aria-label="Search"
                onClick={() => toggleSearch()}
              >
                <CloseMark />
              </button>
            </div>
            {searchResults.length > 0 && (
              <div className="mt-4 search-results">
                <p className="fs-4">
                  <strong>Search Results:</strong>
                </p>
                <ul>
                  {searchResults.map((result, index) => (
                    <li key={index}>
                      <Link href={result.item.url}>
                        <a onClick={() => toggleSearch()}>
                          {result.item.title}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </Container>
        </section>
      )}
    </>
  );
}
